import React from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { FontIcon } from '@fluentui/react';

//component
import PractitionerSettingsForm from '../PractitionerSettingsForm/PractitionerSettingsForm.Component';
import { PractitionerDetailsMini } from "../../../../commons/component/Practitioner/PractitionerDetails/PractitionerDetails.Mini";

// models
import { ProtocolPractitioner } from "../../../../models/Entities/Protocols/ProtocolPractitioner";

// styles
import './ProtocolPractitioner.style.css';

import { Practitioner } from "../../../../models/Entities/Practitioners/Practitioner";
import { ProtocolPractitionerStudyRole } from '../../../../models/Entities/Protocols/ProtocolPractitionerStudyRol';
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';

//i18Next
import { useTranslation } from 'react-i18next';


export interface IProps {
    practitioner: ProtocolPractitionerStudyRole;
    Protocol: Protocol;
    contractId: number;
    GetPractiontioner: (practitionerId: string) => Practitioner | undefined;
}


export const ProtocolPractitionerItemComponent = (props: IProps) => {

    const [t] = useTranslation();

    const [isOpenSettingForm, { setTrue: openSettingFormPanel, setFalse: dismissSettingFormPanel }] = useBoolean(false);

    const isPrincipal = props.practitioner.practitionerUserId === props.Protocol?.principalInvestigatorId;

    return (
        <>
            <button
                className="pp-card-wrapper"
                onClick={openSettingFormPanel}
            >
                <div className={`pp-card${isPrincipal ? ' pp-card--principal' : ''}`}>
                    <div className="pp-card__accent" />
                    <div className="pp-card__body">

                        <div className="pp-card__header">
                            <div className="pp-card__role-group">
                                {isPrincipal && (
                                    <FontIcon iconName="FavoriteStarFill" className="pp-card__star" />
                                )}
                                <span className="pp-card__role">{props.practitioner.studyRole?.name}</span>
                            </div>
                            <FontIcon iconName="Settings" className="pp-card__settings-hint" />
                        </div>

                        <div className="pp-card__practitioner">
                            <PractitionerDetailsMini practitioner={props.GetPractiontioner(props.practitioner.practitionerUserId)} />
                        </div>

                    </div>
                </div>
            </button>

            <PractitionerSettingsForm
                ProtocolId={props.practitioner.protocolId}
                Practitioner={props.practitioner}
                ContractId={props.contractId}
                isOpen={isOpenSettingForm}
                openPanel={openSettingFormPanel}
                dismissPanel={dismissSettingFormPanel}
            />
        </>
    );
}
